/**
 * This component can truncate text AND HTML markup with ellipsis.
 * Inspired by this github issue: https://github.com/One-com/react-truncate/issues/8#issuecomment-262639343
 * This component is not managed by react VDOM and mutates its own DOM
 */
// shim `self`
import React, { Component } from 'react';
import { windowUndefined } from '../../../helpers/serverRenderingUtils';

const Ellipsis = require('imports-loader?self=>{}&window=>{}!ellipsis.js');

class TruncateWithEllipsis extends Component {
  configure() {
    const { lines } = this.props;
    this.ellipsis = Ellipsis({
      ellipsis: '…', // default ellipsis value
      // debounce: 500, //if you want to chill out your memory usage on resizing
      responsive: false, // if you want the ellipsis to move with the window resizing
      class: false,
      lines, // default number of lines when the ellipsis will appear
      break_word: true, // default the ellipsis can truncate words
    });
  }

  UNSAFE_componentWillMount() {
    !windowUndefined() && this.configure();
  }

  componentDidMount() {
    if (this.ellipsis && this.truncateContainer) {
      this.ellipsis.add(this.truncateContainer);
    }
  }

  // Turn off react because we mutate with Ellipsis
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { children } = this.props;
    return (
      <div
        ref={node => {
          this.truncateContainer = node;
        }}
      >
        {children}
      </div>
    );
  }
}

export default TruncateWithEllipsis;
